import type { CarApiRespServerError } from '@autobid/ui/types/Car'

export function prepareMultiErrorCause(errors: CarApiRespServerError['errors']) {
  return errors.map(el => `[${el.status_code}] - ${el.message}`).join(', ')
}
